const ColorMap = new Map();

ColorMap.set('success', '#e7f0db');
ColorMap.set('secondary', 'white');

export default ColorMap;
